import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { Item, Select } from '@components/basics/forms/inputs/Select';
import { NextFutureImage } from '@components/main-components/image/NextFutureImage';
import type { UserNft } from '@hooks/useMultipleNftsForRelease';
import { TIER_NUMBERS } from '@utils/tiers';

export function EditionSelector({
  selectedIndex,
  setSelectedIndex,
  nfts,
  loadMore,
  showCommentedTag,
}: {
  selectedIndex: number;
  setSelectedIndex: (index: number) => void;
  nfts: UserNft[];
  loadMore: () => void;
  showCommentedTag: boolean;
}) {
  const [bottomRef, isAtBottom] = useInView({
    threshold: 0.1,
  });

  useEffect(() => {
    if (isAtBottom) {
      loadMore();
    }
  }, [isAtBottom, loadMore]);

  const nftEditionImage = (nft: UserNft) => {
    if (nft.isGoldenEgg) {
      return (
        <NextFutureImage
          alt="goldenEggBadge"
          src="/images/golden-egg-badge.png"
          className="h-[18px] w-[18px]"
          width={18}
          height={18}
        />
      );
    } else if (nft.tierNumber === TIER_NUMBERS.LIMITED) {
      return (
        <NextFutureImage
          alt="starBadge"
          src="/images/star-badge.png"
          className="h-[18px] w-[18px]"
          width={18}
          height={18}
        />
      );
    } else {
      return (
        <NextFutureImage
          alt="starBadge"
          src="/images/forever-badge.png"
          className="h-[18px] w-[18px]"
          width={18}
          height={18}
        />
      );
    }
  };

  return (
    <Select
      value={selectedIndex.toString()}
      onValueChange={value => {
        setSelectedIndex(parseInt(value));
      }}
      disabled={nfts.length <= 1}
    >
      {nfts &&
        nfts.map((nft, index) => {
          return (
            <Item key={nft.id} value={index.toString()}>
              <div className="flex items-center gap-2">
                <div>{nftEditionImage(nft)}</div>
                <span>#{nft.serialNumber.toString()}</span>
              </div>
              <div className="flex items-center justify-end gap-2 text-right text-base-s">
                {showCommentedTag && nft.comment?.id && (
                  <div className="font-medium text-base500">Commented</div>
                )}
              </div>
            </Item>
          );
        })}
      <div ref={bottomRef} />
    </Select>
  );
}
